// ============================================================================
// reauthFolytatas.js — a friss belépés miatt megszakadt admin-művelet ÁTVIVÉSE lapújratöltésen át (2026-10-22, v135 javítás).
//
// MIÉRT: az újrahitelesítés felugró ablakkal történik, de ahol a böngésző nem tud (vagy nem enged) új ablakot nyitni - beágyazott
// böngészőpanel, kezdőképernyős alkalmazás -, a Google-belépés a LAPOT viszi el, és visszatérve a program újraindul. Ilyenkor a
// memóriában tartott "folytasd a műveletet" függvény elveszne (élő hiba: a belépés sikerült, a szoba törlése mégsem futott le).
// Ezért a megszakadt művelet leírását (csak a művelet neve és a szerverhívás adata: azonosítók, e-mail, név - nincs jelszó, token,
// üzenetszöveg) a böngészőmunkamenet tárolójába (sessionStorage) mentjük, és belépés után a program ebből folytatja.
// A bejegyzés rövid életű (MAX_KOR_MS), egyszer használatos, és csak a négy védett művelet neve fogadható el.
// ============================================================================

export const REAUTH_KULCS = "l0_reauthPending";
export const MAX_KOR_MS = 15 * 60 * 1000;
export const VEDETT_MUVELETEK = ["addUser", "removeUser", "setUserRole", "deleteRoom"];

function tarolo(win) {
  try {
    return win && win.sessionStorage ? win.sessionStorage : null;
  } catch (e) {
    return null;
  }
}

/** A megszakadt művelet mentése. @returns {boolean} sikerült-e */
export function reauthMentes(leiras, ido = Date.now(), win = typeof globalThis !== "undefined" ? globalThis : {}, elinditva = false) {
  if (!leiras || !VEDETT_MUVELETEK.includes(leiras.action) || typeof leiras.payload !== "object" || leiras.payload === null) return false;
  const t = tarolo(win);
  try {
    if (!t) return false;
    t.setItem(REAUTH_KULCS, JSON.stringify({ action: leiras.action, payload: leiras.payload, label: String(leiras.label || "").slice(0, 120), at: ido, started: elinditva === true }));
    return true;
  } catch (e) {
    return false;
  }
}

/** A mentett művelet kiolvasása ÉS törlése (egyszer használatos); lejárt vagy érvénytelen bejegyzés null. */
export function reauthKivesz(ido = Date.now(), win = typeof globalThis !== "undefined" ? globalThis : {}) {
  const t = tarolo(win);
  if (!t) return null;
  let nyers = null;
  try {
    nyers = t.getItem(REAUTH_KULCS);
    t.removeItem(REAUTH_KULCS);
  } catch (e) {
    return null;
  }
  if (!nyers) return null;
  try {
    const o = JSON.parse(nyers);
    if (!o || !VEDETT_MUVELETEK.includes(o.action) || typeof o.payload !== "object" || o.payload === null) return null;
    if (typeof o.at !== "number" || ido - o.at > MAX_KOR_MS || ido - o.at < -60000) return null;
    if (o.started !== true) return null; // a felhasználó nem indította el az újrabelépést
    return { action: o.action, payload: o.payload, label: typeof o.label === "string" ? o.label : "" };
  } catch (e) {
    return null;
  }
}

/**
 * A felhasználó ELINDÍTOTTA az újrabelépést (megnyomta a gombot). Csak ilyen bejegyzést folytat a program lapújratöltés után:
 * egy meg sem erősített, elfelejtett törlés ne induljon el magától később (v138, biztonsági korlát).
 */
export function reauthIndit(win = typeof globalThis !== "undefined" ? globalThis : {}) {
  const t = tarolo(win);
  try {
    if (!t) return false;
    const nyers = t.getItem(REAUTH_KULCS);
    if (!nyers) return false;
    const o = JSON.parse(nyers);
    o.started = true;
    t.setItem(REAUTH_KULCS, JSON.stringify(o));
    return true;
  } catch (e) {
    return false;
  }
}

/** Törlés (pl. sikeres folytatás után, ha a bejegyzés még megvan). */
export function reauthTorol(win = typeof globalThis !== "undefined" ? globalThis : {}) {
  const t = tarolo(win);
  try {
    if (t) t.removeItem(REAUTH_KULCS);
  } catch (e) {
    /* nem kritikus */
  }
}

/** A művelet sikeres / sikertelen állapotsorának felirat-kulcsa. */
export const ALLAPOT_KULCSOK = {
  addUser: { ok: "admin.userAdded", hiba: "admin.addUserFailed" },
  setUserRole: { ok: "admin.roleChanged", hiba: "admin.roleFailed" },
  removeUser: { ok: "admin.userRemoved", hiba: "admin.removeFailed" },
  deleteRoom: { ok: "admin.roomDeleted", hiba: "admin.deleteRoomFailed" },
};
